import { getUrlToLogoutCallbackInStorage, setUrlToLogoutCallbackInStorage } from '../../../shared';
import routerHistory from '../../../routerHistory';
import { ROUTES } from '../../../const';
import * as _ from 'lodash';

/**
 * After logout operations
 */
export let afterLogout = () => {
  return () => {
    let urlToLogout = getUrlToLogoutCallbackInStorage();
    setUrlToLogoutCallbackInStorage();
    if (_.isEmpty(urlToLogout) || urlToLogout === 'undefined') {
      routerHistory.push(ROUTES.LOGIN);
    } else if (_.eq(urlToLogout, 'close')) {
      window.close();
    } else {
      window.location = urlToLogout;
    }
  };
};

export const sendExpiredTokenNotification = expired => {
  // do nothing, only in electron
};
